"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ClosingConsultation() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLElement>({
    threshold: 0.15
  });
  return <section id="closingconsultationcta" data-nav="light" ref={ref} className="bg-background text-foreground py-20 lg:py-28 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div style={{
        opacity: isVisible ? 1 : 0
      }} className={`grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center transition-all duration-700 ease-out ${isVisible ? "translate-y-0" : "translate-y-6"}`}>
          <div className="lg:col-span-6 space-y-6">
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-foreground tracking-tight leading-tight">
              Have questions about your upcoming renovation?
            </h2>

            <p className="text-muted-foreground text-lg leading-relaxed max-w-xl">
              Every home and layout is unique. Connect with our remodeling team to discuss your architectural ideas, structural questions, and project timeline.
            </p>

            <div className="pt-2">
              <Button asChild size="lg" className="px-7 py-3 text-base">
                <Link to="/ContactRequestAnEstimatePage">
                  Get in Touch
                  <ArrowRight className="size-4 ml-1" />
                </Link>
              </Button>
            </div>
          </div>

          <div className="lg:col-span-6">
            <div className="relative rounded-2xl overflow-hidden shadow-xl border border-border bg-muted">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1821096/img/brookhaven_kitchen_interior_renovation.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1821096/img/brookhaven_kitchen_interior_renovation.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1821096/img/brookhaven_kitchen_interior_renovation.webp-wvc-sizes" alt="Custom residential kitchen remodeling project featuring natural wood cabinetry and marble island in Brookhaven" loading="lazy" decoding="async" className="w-full h-[360px] sm:h-[420px] lg:h-[480px] object-cover" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}